import { formatNumber } from '@angular/common';
import { inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'volumePercentage',
  standalone: true,
})
export class VolumePercentagePipe implements PipeTransform {
  readonly #localId = inject(LOCALE_ID);

  public transform(value: number, sum: number): string {
    const percentage = (value / sum) * 100;
    const min = 0.01;
    return percentage < min ? `< ${this.#transformValue(min)}` : this.#transformValue(percentage);
  }

  #transformValue = (value: number): string => `${formatNumber(value, this.#localId, '1.2-2')} %`;
}
